window.isNumberValidate = function(e) {
    var charCode = (e = e || window.event).which || e.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57 || charCode > 107 || charCode > 219 || charCode > 221) && charCode != 40 && charCode != 32 && charCode != 41 && (charCode < 43 || charCode > 46));
};

window.isAlfa = function(e) {
    var charCode = (e = e || window.event).which || e.keyCode;
    return !(charCode > 32 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122));
};


export function initCareerForm() {
    const form = document.querySelector("form#CareerContactForm");
    if (form) {
        // File change handler to show selected file name(s)
        const docInput = document.getElementById("document-career");
        if (docInput) {
            docInput.addEventListener("change", function() {
                const fileMsg = form.querySelector(".file-msg");
                if (!fileMsg) return;

                if (this.files.length === 0) {
                    fileMsg.textContent = "No file chosen";
                } else if (this.files.length === 1) {
                    fileMsg.textContent = this.files[0].name;
                } else {
                    fileMsg.textContent = this.files.length + " files selected";
                }
            });
        }

        form.addEventListener("submit", async function(e) {
            e.preventDefault();
            let isValid = true;
            let invalidFileType = false;

            // Reset error messages and styling
            form.querySelectorAll(".form-group").forEach(group => {
                group.classList.remove("error-message");
            });
            form.querySelectorAll(".cfValidationMessage").forEach(msg => {
                msg.classList.add("displayNone");
                msg.classList.remove("error-text");
            });
            
            const successMsg = form.querySelector("span.contact-success-text");
            const errorMsg = form.querySelector("span.contact-error-text");
            if (successMsg) successMsg.style.display = "none";
            if (errorMsg) errorMsg.style.display = "none";

            // Validate all text inputs (except optional phone, mobile, and document)
            form.querySelectorAll("input").forEach(input => {
                const val = input.value.trim();
                const id = input.id;
                const type = input.getAttribute("type");
                
                const name = input.getAttribute("name");
                
                // Ignore hidden inputs, file inputs, inputs without a name, or inputs inside custom selects
                if (type === "hidden" || type === "file" || !name || input.closest("[class*='ss-']") || id === "mo_number" || id === "ph_number" || id === "document-career") {
                    return;
                }
                
                if (val === "") {
                    isValid = false;
                    const group = input.closest(".form-group");
                    if (group) {
                        group.classList.add("error-message");
                        const errSpan = group.querySelector(".cfValidationMessage");
                        if (errSpan) errSpan.classList.remove("displayNone");
                    }
                }
            });

            // Validate selects
            form.querySelectorAll("select").forEach(select => {
                const val = (typeof jQuery !== 'undefined') ? jQuery(select).val() : select.value;
                console.log("Select validation - ID:", select.id, "Read Value:", val);
                
                if (!val || val.trim() === "") {
                    isValid = false;
                    const group = select.closest(".form-group");
                    if (group) {
                        group.classList.add("error-message");
                        const errSpan = group.querySelector(".cfValidationMessage");
                        if (errSpan) errSpan.classList.remove("displayNone");
                    }
                }
            });

            // Validate Email
            const emailInput = form.querySelector("input#email");
            const emailRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (emailInput) {
                const emailVal = emailInput.value.trim();
                const group = emailInput.closest(".form-group");
                if (emailVal === "") {
                    isValid = false;
                    if (group) {
                        group.classList.add("error-message");
                        const errSpan = group.querySelector(".cfValidationMessage");
                        if (errSpan) {
                            errSpan.textContent = "Please enter your Email Address";
                            errSpan.classList.remove("displayNone");
                        }
                    }
                } else if (!emailRegex.test(emailVal)) {
                    isValid = false;
                    if (group) {
                        group.classList.add("error-message");
                        const errSpan = group.querySelector(".cfValidationMessage");
                        if (errSpan) {
                            errSpan.textContent = "Please enter valid Email Address";
                            errSpan.classList.remove("displayNone");
                        }
                    }
                }
            }

            const phoneRegex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

            // Validate Phone Number
            const phInput = form.querySelector("input#ph_number");
            if (phInput) {
                const phVal = phInput.value.trim();
                if (phVal !== "" && !phoneRegex.test(phVal)) {
                    isValid = false;
                    const group = phInput.closest(".form-group");
                    if (group) {
                        group.classList.add("error-message");
                        const errSpan = group.querySelector(".cfValidationMessage");
                        if (errSpan) {
                            errSpan.textContent = "Please enter valid Phone Number";
                            errSpan.classList.remove("displayNone");
                        }
                    }
                }
            }

            // Validate Mobile Number
            const moInput = form.querySelector("input#mo_number");
            if (moInput) {
                const moVal = moInput.value.trim();
                if (moVal !== "" && !phoneRegex.test(moVal)) {
                    isValid = false;
                    const group = moInput.closest(".form-group");
                    if (group) {
                        group.classList.add("error-message");
                        const errSpan = group.querySelector(".cfValidationMessage");
                        if (errSpan) {
                            errSpan.textContent = "Please enter valid Mobile Number";
                            errSpan.classList.remove("displayNone");
                        }
                    }
                }
            }

            // Compare Mobile and Phone Numbers (must be different if both are filled)
            if (phInput && moInput) {
                const phVal = phInput.value.trim();
                const moVal = moInput.value.trim();
                if (phVal !== "" && moVal !== "" && phoneRegex.test(phVal) && phoneRegex.test(moVal) && phVal === moVal) {
                    isValid = false;
                    const group = phInput.closest(".form-group");
                    if (group) {
                        group.classList.add("error-message");
                        const errSpan = group.querySelector(".cfValidationMessage");
                        if (errSpan) {
                            errSpan.textContent = "Please enter different Phone number";
                            errSpan.classList.remove("displayNone");
                        }
                    }
                }
            }

            // Validate Document File (10MB limit and formats)
            const docInput = document.getElementById("document-career");
            if (docInput && docInput.files.length > 0) {
                let totalSize = 0;
                const allowedMimeTypes = [
                    "application/msword",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "application/vnd.ms-powerpoint",
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "application/zip",
                    "application/x-zip-compressed",
                    "application/pdf",
                    "text/plain"
                ];
                const allowedExtensions = ["doc", "docx", "ppt", "pptx", "xls", "xlsx", "pdf", "zip", "txt"];

                for (let i = 0; i < docInput.files.length; i++) {
                    const file = docInput.files[i];
                    totalSize += file.size / 1024 / 1024;

                    if (file.type !== "") {
                        if (!allowedMimeTypes.includes(file.type)) {
                            isValid = false;
                            invalidFileType = true;
                        }
                    } else {
                        const extension = file.name.split(".").pop().toLowerCase();
                        if (!allowedExtensions.includes(extension)) {
                            isValid = false;
                            invalidFileType = true;
                        }
                    }
                }

                const docGroup = docInput.closest(".form-group");
                if (totalSize > 10) {
                    isValid = false;
                    if (docGroup) {
                        docGroup.classList.add("error-message");
                        const errSpan = docGroup.querySelector(".cfValidationMessage.documentUploadError");
                        if (errSpan) errSpan.classList.remove("displayNone");
                    }
                }

                if (invalidFileType) {
                    isValid = false;
                    if (docGroup) {
                        docGroup.classList.add("error-message");
                        const errSpan = docGroup.querySelector(".cfValidationMessage.typeInvalidError");
                        if (errSpan) errSpan.classList.remove("displayNone");
                    }
                }
            }

            if (!isValid) {
                return false;
            }

            // AJAX Form Submission
            const loader = form.querySelector("span.ajax-loader");
            if (loader) loader.classList.add("active");

            const formData = new FormData(form);
            const actionUrl = form.getAttribute("action");

            try {
                const response = await fetch(actionUrl, {
                    method: "POST",
                    body: formData
                });
                const result = await response.json();

                if (result.success == 1) {
                    if (successMsg) successMsg.style.display = "block";
                    form.reset();
                    
                    form.querySelectorAll(".form-group").forEach(group => {
                        group.classList.remove("error-message");
                    });
                    if (docInput) docInput.value = "";
                    const fileMsg = form.querySelector(".file-msg");
                    if (fileMsg) fileMsg.textContent = "No file chosen";
                } else {
                    if (errorMsg) errorMsg.style.display = "block";
                }
            } catch (error) {
                console.error(error);
                if (errorMsg) errorMsg.style.display = "block";
            } finally {
                if (loader) loader.classList.remove("active");
            }
        });
    }

    // Apply Now Job Title Population
	document.addEventListener("click", function (e) {
        // Match either class or ID for the apply button
        const applyBtn = e.target.closest("#apply-now, .apply-now");
        if (applyBtn) {
            e.preventDefault();
            
            let jobTitleText = "";
            let hiddenInput = null;
            
            // 1. Try finding hidden input as direct sibling of the button
            if (applyBtn.parentElement) {
                hiddenInput = Array.from(applyBtn.parentElement.children)
                    .find(el => el.tagName === "INPUT" && el.type === "hidden");
            }
            
            // 2. Fallback: Search anywhere within the parent element
            if (!hiddenInput && applyBtn.parentElement) {
                hiddenInput = applyBtn.parentElement.querySelector("input[type='hidden']");
            }
            
            // 3. Fallback: Search in the closest job container/wrapper (e.g., card, list item)
            if (!hiddenInput) {
                const jobContainer = applyBtn.closest(".job-item, .job-card, .our-opening-card, .career-item, .card, li, tr, div");
                if (jobContainer) {
                    hiddenInput = jobContainer.querySelector("input[type='hidden']");
                }
            }
            
            if (hiddenInput) {
                jobTitleText = hiddenInput.value;
            } else {
                // 4. Fallback: Extract job title from header elements (e.g. .opening-card-inner h3 a)
                const cardContainer = applyBtn.closest(".our-opening-card, .job-card, .job-item, div");
                if (cardContainer) {
                    const titleElement = cardContainer.querySelector("h3 a") || cardContainer.querySelector(".opening-card-inner h3") || cardContainer.querySelector("h3");
                    if (titleElement) {
                        const cloned = titleElement.cloneNode(true);
                        cloned.querySelectorAll("img, svg, span").forEach(el => el.remove());
                        jobTitleText = cloned.textContent.trim();
                    }
                }
            }
            
            if (jobTitleText) {
                const jobTitleInput = document.getElementById("job-title");
                if (jobTitleInput) {
                    jobTitleInput.value = jobTitleText;
                }
            } else {
                console.warn("Apply clicked, but no job title could be found relative to the button.");
            }
        }
    });
}